import QuestionAnswerSection from './QuestionTypeManager.react';

export default QuestionAnswerSection;
